import { render, staticRenderFns } from "./sidebarmenu.vue?vue&type=template&id=28b63c88&scoped=true&"
import script from "./sidebarmenu.vue?vue&type=script&lang=js&"
export * from "./sidebarmenu.vue?vue&type=script&lang=js&"
import style0 from "./sidebarmenu.vue?vue&type=style&index=0&id=28b63c88&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b63c88",
  null
  
)

export default component.exports